"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.joinRaceByParticipantId = void 0;
const axios_1 = __importDefault(require("axios"));
/**
 * Signs a member up for participating in a specific race by given ID (if it exists).
 *
 * Race is identified by its stringified `ObjectID`.
 * Member is identified by their Discord ID.
 *
 * ## Usage
 * ```ts
 * const raceId: string = "5f5e555d5a578b6";
 * const memberId: string = "90876543782";
 *
 * const {
 * 	acknowledged,
 * 	insertedId,
 * } = await sdk.joinRaceByParticipantId({ raceId, memberId });
 * ```
 *
 * @param params.raceId   - ID of a race to sign a member to.
 * @param params.memberId - ID of a member that wishes to sign into a race.
 */
const joinRaceByParticipantId = (params, 
/** @ignore */
BASE_URL) => __awaiter(void 0, void 0, void 0, function* () {
    const { raceId, memberId } = params;
    const url = `${BASE_URL}/races/race/${raceId}/participants/participant/${memberId}`;
    const racePlayerResponse = yield axios_1.default.post(url, {}, { validateStatus: () => true });
    const { status, data } = racePlayerResponse;
    if (status !== 201)
        throw new Error(data.error);
    return data;
});
exports.joinRaceByParticipantId = joinRaceByParticipantId;
